module.exports = __webpack_public_path__ + "static/media/Banner-Ortho.7b0163dc.png";